import React from "react";

const Youtube = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 18">
      <defs/>
      <path fill-rule="evenodd" d="M25.078 2.813c.219.843.375 2.124.469 3.843L25.594 9l-.047 2.344c-.094 1.75-.25 3.047-.469 3.89-.156.532-.437 1-.844 1.407a3.25 3.25 0 01-1.453.843c-.812.22-2.718.375-5.718.47L12.796 18l-4.266-.047c-3-.094-4.906-.25-5.719-.469a3.25 3.25 0 01-1.453-.843 3.269 3.269 0 01-.843-1.407c-.22-.843-.375-2.14-.47-3.89L0 9c0-.688.016-1.469.047-2.344.094-1.719.25-3 .469-3.843a3.25 3.25 0 01.843-1.454A3.25 3.25 0 012.813.516C3.625.296 5.53.14 8.53.046L12.797 0l4.265.047c3 .094 4.907.25 5.72.469a3.25 3.25 0 011.452.843c.407.407.688.891.844 1.454zm-14.906 10.03L16.875 9l-6.703-3.797v7.64z"/>
    </svg>
  );
};

export default Youtube;
